var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.showAvisoNotificacao
        ? _c("app-aviso-notificacao", {
            attrs: {
              conversasAbertas: _vm.conversaAberta,
              prolongado: _vm.conversaAberta[0].prolongado
            },
            on: { prolongado: _vm.carregarConversas }
          })
        : _vm._e(),
      _c(
        "app-lista-conversas",
        { attrs: { loading: _vm.loading } },
        [
          _c("app-paginacao", {
            attrs: {
              total: _vm.totalConversas || 0,
              pagina: _vm.pagina,
              tamanhoPagina: 10
            },
            on: { changePage: _vm.changePage }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4f4f5924", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f4f5924","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/central/components/centralMensagens/AppCentralMensagens.vue
// module id = null
// module chunks = 